import { PaymentMethodInterface } from "@/interface/business/payment.interface";
import { ItemImageType } from "@/types/business/item.type";
import { PaymentMethodType } from "@/types/business/payment.type";

export class PaymentMethod implements PaymentMethodInterface {
  id: string = "";
  name: string = "";
  label: string = "";
  type: string = "";
  commission: number = 0;
  is_generic: boolean = false;
  icon?: ItemImageType;
  selected: boolean = false;

  constructor(data: PaymentMethodType, isSelected: boolean = false) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.label = data.label;
      this.type = data.type;
      this.commission = data.commission;
      this.is_generic = data.is_generic;
      this.icon = data.icon;
    }

    this.selected = isSelected;
  }

  /**
   * Set is selected payment method
   * @param select
   */
  public setSelected(select): void {
    this.selected = select;
  }
}
